import { render, staticRenderFns } from "./PriceListTable.vue?vue&type=template&id=0db244f5&scoped=true&"
import script from "./PriceListTable.vue?vue&type=script&lang=js&"
export * from "./PriceListTable.vue?vue&type=script&lang=js&"
import style0 from "./PriceListTable.vue?vue&type=style&index=0&id=0db244f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db244f5",
  null
  
)

export default component.exports